<toolbar-halls *renderIf="{mediaSelector:'gt-md'}" class="hidden lg:block sticky top-16 lg:top-[120px]"></toolbar-halls>
<div #header class="w-full h-fit">
  <news-archive-header  *renderIf="{mediaSelector:'gt-md'}" class="w-full hidden md:block"></news-archive-header>
  <news-archive-headerResponsive *renderIf="{mediaSelector:'lt-md'}" class="w-full md:hidden"></news-archive-headerResponsive>
</div>
<content class="container pb-12 pt-4">
  <paged-virtual-scroller
    [scrollWithMainScrollbar]="true"
    [itemTpl]="newsScrollerTpl"
    [pageSize]="2"
    [scaleUpOnRender]="false"
    [itemHeight]="(265 + 25)"
    [itemWidth]="(400 + 25)"
    seoFriendly="offset-cursor"
    [itemsQuery]="newsQuery"
    class="w-full">
  </paged-virtual-scroller>

  <ng-template let-item #newsScrollerTpl>
    <news-block
      class="w-[290px] h-[192px] md:w-[400px] md:h-[265px]"
      #newsBlock
      [newsItem]="item"
      [imageSizes]="[{ w: 400, h: 225, resizeMode: 'fill' }]"
      [general]="true">
    </news-block>
  </ng-template>
</content>
@defer(on timer(5s)) {
  <exp-footer class="text-orange"></exp-footer>
}